import Skeleton from "../../../Components/Common/Skeleton/Skeleton";

interface OwnerSignDrawRequestSectionProps {
  loading?: boolean;
  bankName?: string;
  isVisible?: boolean;
}

function OwnerSignDrawRequestSkeleton() {
  return (
    <div className="sign-draw-skel-wrap">
      <div className="card sign-draw-skel-card-1">
        <Skeleton variant="text" width="34%" height={26} />
        <Skeleton variant="text" width="72%" height={16} />
        <Skeleton variant="text" width="58%" height={16} />
      </div>

      <div className="card sign-draw-skel-card-2">
        <Skeleton variant="text" width="28%" height={22} />
        <Skeleton variant="card" width="100%" height={120} borderRadius={12} />
        <Skeleton variant="card" width="100%" height={120} borderRadius={12} />
      </div>
    </div>
  );
}

export default function OwnerSignDrawRequestSection({
  loading,
  bankName,
  isVisible,
}: OwnerSignDrawRequestSectionProps) {
  if (loading) {
    return <OwnerSignDrawRequestSkeleton />;
  }

  return (
    <div className="sign-draw-header">
      <div className="section-title">Sign Draw Request</div>
      {isVisible && (
        <p className="sign-draw-sub">
          Review the AIA Application for Payment and sign below. Your signature
          is required before {bankName} can process this draw.
        </p>
      )}
    </div>
  );
}
